function extractCharCode(str) {
  return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}
export {
  extractCharCode
};
//# sourceMappingURL=extractCharCode.mjs.map
